/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import is from '../../is/index';

/**
 * Formats a user's name to use in an Avatar icon
 *
 * @param {String} name The name to process.
 * @example
 *
 * formatEndUserName('Jane Doe');
 * // -> 'JD'
 *
 * formatEndUserName('John');
 * // -> 'JO'
 *
 *  * formatEndUserName('T');
 * // -> 'T'
 */

const formatEndUserName = (name) => {
  if (!name || !is.string(name)) {
    return;
  }
  if (name.length === 1) {
    return name;
  }

  const nameParts = name.split(' ', 2);
  let formattedName;
  if (nameParts.length >= 2) {
    formattedName = nameParts[0][0] + nameParts[1][0];
  } else {
    formattedName = nameParts[0][0] + nameParts[0][1];

  }
  return formattedName.toUpperCase();
};

export default formatEndUserName;
